import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center bg-white text-zinc-900 grid-bg" data-testid="checkout-cancel-page">
      <div className="rounded-3xl border border-black/5 bg-white border border-black/5 shadow-sm p-10 max-w-md w-full text-center">
        <XCircle className="mx-auto h-12 w-12 text-amber-400" />
        <h2 className="mt-4 font-display text-2xl font-bold">Checkout cancelled</h2>
        <p className="mt-2 text-sm text-zinc-500">No charges were made.</p>
        <button onClick={() => nav("/billing")} className="mt-6 rounded-full ashra-gradient-bg px-5 py-2.5 text-sm font-medium" data-testid="back-billing">Back to billing</button>
      </div>
    </div>
  );
}
